"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adjustMetadataByCountry = adjustMetadataByCountry;
exports.adjustPriceByCountry = adjustPriceByCountry;
exports.adjustPricingGridByCountry = adjustPricingGridByCountry;
exports.countryRatios = exports.countryDeliveryFees = void 0;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var getRatioForCurrency = function getRatioForCurrency(currency) {
  if (currency === 'EUR') {
    return 1;
  }
  if (currency === 'GBP') {
    return 0.83;
  }
  throw new Error("Unsupported currency: ".concat(currency));
};
var countryRatios = exports.countryRatios = {
  FR: 1 * getRatioForCurrency('EUR'),
  DE: 1.333333333 * getRatioForCurrency('EUR'),
  UK: 1.833333333 * getRatioForCurrency('GBP'),
  IT: 1 * getRatioForCurrency('EUR'),
  ES: 0.916666667 * getRatioForCurrency('EUR'),
  NL: 1.333333333 * getRatioForCurrency('EUR'),
  CH: 2.083333333 * getRatioForCurrency('EUR'),
  BE: 1.166666667 * getRatioForCurrency('EUR'),
  SE: 2 * getRatioForCurrency('EUR'),
  PL: 0.833333333 * getRatioForCurrency('EUR'),
  NO: 2 * getRatioForCurrency('EUR'),
  AT: 1.333333333 * getRatioForCurrency('EUR'),
  DK: 1.833333333 * getRatioForCurrency('EUR'),
  FI: 1.833333333 * getRatioForCurrency('EUR'),
  GR: 0.833333333 * getRatioForCurrency('EUR'),
  PT: 0.916666667 * getRatioForCurrency('EUR'),
  CZ: 0.833333333 * getRatioForCurrency('EUR'),
  HU: 0.833333333 * getRatioForCurrency('EUR'),
  RO: 0.833333333 * getRatioForCurrency('EUR'),
  BG: 0.833333333 * getRatioForCurrency('EUR'),
  HR: 0.833333333 * getRatioForCurrency('EUR'),
  RS: 0.833333333 * getRatioForCurrency('EUR'),
  SK: 0.833333333 * getRatioForCurrency('EUR'),
  SI: 1 * getRatioForCurrency('EUR'),
  EE: 1 * getRatioForCurrency('EUR'),
  LV: 0.833333333 * getRatioForCurrency('EUR'),
  LT: 0.833333333 * getRatioForCurrency('EUR'),
  LU: 2 * getRatioForCurrency('EUR'),
  LI: 2 * getRatioForCurrency('EUR'),
  CY: 1 * getRatioForCurrency('EUR'),
  MT: 1 * getRatioForCurrency('EUR'),
  IE: 1.833333333 * getRatioForCurrency('EUR')
};
var countryDeliveryFees = exports.countryDeliveryFees = {
  FR: 5,
  DE: 7,
  UK: 8,
  IT: 5,
  ES: 5,
  NL: 7,
  CH: 10,
  BE: 6,
  SE: 10,
  PL: 4,
  NO: 10,
  AT: 7,
  DK: 9,
  FI: 9,
  GR: 4,
  PT: 5,
  CZ: 4,
  HU: 4,
  RO: 4,
  BG: 4,
  HR: 4,
  RS: 4,
  SK: 4,
  SI: 5,
  EE: 5,
  LV: 4,
  LT: 4,
  LU: 10,
  LI: 10,
  CY: 5,
  MT: 5,
  IE: 9
};
function adjustPrice(price, ratio) {
  var epsilon = 0.01;
  return Math.ceil(price * ratio - epsilon);
}
function adjustPricesInObject(obj, ratio) {
  if (_typeof(obj) !== 'object' || obj === null) {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map(function (item) {
      return adjustPricesInObject(item, ratio);
    });
  }
  var result = {};
  Object.entries(obj).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if (key === 'prices' || key === 'liningPrices') {
      result[key] = Object.fromEntries(Object.entries(value).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          k = _ref4[0],
          v = _ref4[1];
        return [k, adjustPrice(v, ratio)];
      }));
    } else if (_typeof(value) === 'object' && value !== null) {
      result[key] = adjustPricesInObject(value, ratio);
    } else if (key === 'price' && typeof value === 'number') {
      result[key] = adjustPrice(value, ratio);
    } else {
      result[key] = value;
    }
  });
  return result;
}
function getCurrencyByCountryCode(countryCode) {
  return countryCode === 'UK' ? 'GBP' : 'EUR';
}
function adjustMetadataByCountry(metadata, countryCode) {
  var upperCountryCode = countryCode.toUpperCase();
  var deliveryFee = countryDeliveryFees[upperCountryCode];
  if (deliveryFee === undefined) {
    throw new Error("No delivery fee defined for country code: ".concat(countryCode));
  }
  return _objectSpread(_objectSpread({}, metadata), {}, {
    deliveryFee: deliveryFee,
    currency: getCurrencyByCountryCode(upperCountryCode)
  });
}
function adjustPricingGridByCountry(pricingGrid, countryCode) {
  var upperCountryCode = countryCode.toUpperCase();
  var ratio = countryRatios[upperCountryCode];
  if (ratio === undefined) {
    throw new Error("No ratio defined for country code: ".concat(countryCode));
  }
  var adjustedPrices = adjustPricesInObject(pricingGrid, ratio);
  adjustedPrices.currency = getCurrencyByCountryCode(countryCode);
  return adjustedPrices;
}
function adjustPriceByCountry(price, countryCode) {
  var upperCountryCode = countryCode.toUpperCase();
  var ratio = countryRatios[upperCountryCode];
  if (ratio === undefined) {
    throw new Error("No ratio defined for country code: ".concat(countryCode));
  }
  return adjustPrice(price, ratio);
}